











































import {Vue, Component } from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
import VLazyImage from 'v-lazy-image';
import Title from '@/components/Title';
import NewsTile from '@/components/NewsTile';

@Component({
  name: 'NewsItem',
  components: {
    NewsTile, Title, VLazyImage,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    this.clearNewsItem();
  },
  watch: {
    id() {
      this.fetchData();
    },
  },
  computed: {
    ...mapGetters('news', ['newsItem', 'similarTitle', 'similarLinkText', 'similarNewsItems', 'promoText']),
  },
  methods: {
    ...mapActions('news', ['fetchTranslation', 'getNewsById', 'clearNewsItem', 'getSimilarNewsById']),

    srcImg(img) {
      return img && `${img[3600]}` || '';
    },

    srcImgPlaceholder(img) {
      return img && `${img[400]}`;
    },

    srcSet(img) {
      return img && `${img[400]} 400w, ${img[800]} 800w,
      ${img[1300]} 1300w, ${img[1900]} 1900w, ${img[3600]} 3600w`;
    },

    formattingDate(date) {
      return this.$dayjs(date).format('DD/MM/YYYY');
    },

    fetchData() {
      this.getNewsById(this.id);
      this.getSimilarNewsById(this.id);
      this.fetchTranslation();
    },
  },
})
export default class NewsItem extends Vue {}
